import angular from 'angular';
import loansHeaderComponent from './loansHeader.component';

let loansHeaderModule = angular.module('loansHeader', [])

  .component('loansHeader', loansHeaderComponent)

  .name;

export default loansHeaderModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansHeader/loansHeader.js